$(document).ready(function () {
  // Add CTA under TikTok
  if ($("body").hasClass("template-index") && $("#mintty-tiktok-feed").length) {
    var btnHtml =
      '<div class="custom-tiktok-btn text-center"><a target="_blank" href="https://www.tiktok.com/@thepcosmentor" class="self-btn btn">Get Social</a></div>';
    $("#mintty-tiktok-feed").after(btnHtml);
  }
  $(".desclaimer-section button").click();
  $(".testimonial-blocks-slider").slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
  });
  $(".testimonials--slider").slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });

  // Index Marquee Slider

  jQuery('.slider_primary_main .slider_primary').marquee({
    duration: 20000,
    pauseOnHover: false,
    gap: 0,
    duplicated: true,
    startVisible: true,
    direction: 'up',
  });

  jQuery('.slider_primary_reverse').marquee({
    duration: 20000,
    pauseOnHover: false,
    gap: 0,
    duplicated: true,
    startVisible: true,
    direction: 'down',
  });

  jQuery('.slider_primary_main_mobile .slider_primary').slick({
    vertical: true,
    verticalSwiping: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 6000,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: 'linear',
    arrows: false,
    dots: false,
    infinite: true,
    responsive: [
    {
      breakpoint: 1201,
      settings: {
        vertical: false,
        slidesToShow: 3,
        infinite: true,
      }
    },
    {
      breakpoint: 600,
      settings: {
        vertical: false,
        slidesToShow: 2,
      }
    },
    {
      breakpoint: 480,
      settings: {
        vertical: false,
        slidesToShow: 2,
      }
    }
  ]
  });

  // jQuery('.slider_primary_reverse').slick({
  //   vertical: true,
  //   verticalSwiping: false,
  //   slidesToShow: 1,
  //   slidesToScroll: -1,
  //   speed: 10000,
  //   autoplay: true,
  //   autoplaySpeed: 0,
  //   cssEase: 'linear',
  //   arrows: false,
  //   dots: false,
  //   infinite: true,
  // });
  
  // Index Marquee Slider Ends

$('.subscribe_image_text').find('.grid').slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      dots:true,
      arrows:true,
      responsive: [
         {
            breakpoint: 991,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
           },
        },
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 1,
             slidesToScroll: 1
           },
        },
     
      ],
});


// about page js
  function iconSlider(){
    $('.about_text_image .grid').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots:true,
    arrows:true,
    prevArrow:'<div class="custom-prev-arrow"><img src="https://cdn.shopify.com/s/files/1/0021/8909/9090/files/Slider_Arrow_ba71e645-9c15-499d-a1bf-9fef5ba8f850.svg?v=1731499227"></div>',
    nextArrow:'<div class="custom-next-arrow"><img src="https://cdn.shopify.com/s/files/1/0021/8909/9090/files/Slider_Arrow_1_6bdfe1e6-c163-438b-b53c-df9438cde4a3.svg?v=1731499334"></div>'  
   });
  }
 if ($(window).width() < 768) {
      iconSlider();
  }
  $(window).resize(function() {
    if ($(window).width() < 768) {
        iconSlider();
    }else{
       $('.about_text_image .grid').slick('unslick');
    }
});
      
  


  $('a[href^="#"].smooth-redirect').on("click", function (e) {
    e.preventDefault();
    var target = this.hash;
    var $target = $(target);
    $("html, body")
      .stop()
      .animate(
        {
          scrollTop: $target.offset().top,
        },
        900,
        "swing",
        function () {
          // window.location.hash = target;
        }
      );
  });

  $(".site-nav__item [data-hover='true']").hover(
    function () {
      $(this).prop("open", true);
    },
    function () {
      $(this).prop("open", false);
    }
  );

  $(document).on("click", "button.footer__title", function () {
    $("button.footer__title").removeClass("is-open");
    $("button.footer__title").attr("aria-expanded", "false");
    $(".collapsible-content--small").removeClass("is-open");
    $(".collapsible-content--small").css("height", "0px");
    $(this).attr("aria-expanded", "true");
    // $(this).addClass('is-open');
    $(this).toggleClass("is-open");
    if ($(this).hasClass("is-open")) {
      var height = $(this)
        .next()
        .find(".collapsible-content__inner")
        .outerHeight();
      $(this).next().addClass("is-open").css("height", height);
    } else {
      $(this).removeClass("is-open");
      $(this).next().removeClass("is-open").css("height", "0px");
    }
  });


  
$('.select-filter').click(function(){
    // alert();
   let filterValue =  $(this).attr('data-value');
    // console.log(filterValue);

   location.href = filterValue;
});



  

});

$(window).on("load", function () {
  document
    .querySelector(".product-overview button")
    .dispatchEvent(new Event("click"));
  document
    .querySelector(".site-footer .grid .grid__item:first-child button")
    .dispatchEvent(new Event("click"));

  $(".active-collection-text").text(
    $(".colection--link.active").attr("data-text")
  );
});


// subscription
$(document).ready(function () {
  let variantButton = $(".variant-wrapper").find('input[type="radio"]');
  //console.log(variantButton);

  $(variantButton).change(function name(params) {
    //console.log('change');
    let findPrice = $(this)
      .closest(".product-single__meta")
      .find(".product-block--price");
    let finalPrice = $(findPrice).find(".custom-product-price span").text();
    let compare_price = $(findPrice).find(".product__price--compare span").text();
    //console.log(finalPrice);
    $(".product-price").text(finalPrice);
    $(".product-compare-at-price span").text(compare_price);
  });

  $(".collection-sidebar__group-mobile .collapsible-trigger").click(
    function () {
      var $collapsibleContent = $(this).next(".collapsible-content");

      $collapsibleContent.toggleClass("is-open");
      if ($collapsibleContent.hasClass("is-open")) {
        $collapsibleContent.css("height", "auto");
      } else {
        $collapsibleContent.css("height", 0);
      }
    }
  );
  

 // product images slider
    $('.product-slideshow').slick({
     infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      asNavFor: '.product__thumbs--scrollers'
    });
    $('.product__thumbs--scrollers').slick({
      slidesToShow: 4,
       infinite: true,
      slidesToScroll: 1,
      asNavFor: '.product-slideshow',
      focusOnSelect: true
    });
 
  // end 
  
  document
    .querySelector(".desclaimer-section button")
    .dispatchEvent(new Event("click"));
  document
    .querySelector(".author-details button")
    .dispatchEvent(new Event("click"));
     
 
});
$(document).ready(function(){
   document.querySelector(".footer__item-padding .contact-button").dispatchEvent(new Event("click"));
  
});

if (!document.documentElement.classList.contains("js-drawer-open")) {
  document
    .querySelector(".collection-sidebar__group-desktop button")
    .dispatchEvent(new Event("click"));
  document
    .querySelector(".collection-sidebar__group button")
    .dispatchEvent(new Event("click"));
}

